import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import NumberFormat from 'react-number-format';
import getConfig from '../../../../config';
import { projectTypes } from '../../../../constans/constans';
import {
  buildGatewayUrl, initIPFS, getFilesFromDirWithContent,
} from '../../../../state/ipfs';
import { getProjectType } from '../../../../utils/helpers';
import CustomBtn from '../../../../generic/CustomBtn';
import DownloadZone from '../../../DownloadZone';
import MapMini from '../../../Map/components/MapMini/MapMini';

const { projectDurationType } = getConfig();

const Preview = ({ state, setStep, prevPage, handleMint, step }) => {
  const translate = useIntl();
  const [iconHash, setIconHash] = useState('');
  const [, setScreenHash] = useState('');
  const [filesNames, setFilesNames] = useState([]);
  const backTo = () => {
    prevPage();
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    if (step === 3) {
      (async () => {
        const ipfs = await initIPFS();
        if (state.filesCidDir) {
          const updateArray = await getFilesFromDirWithContent(ipfs, state.filesCidDir, signal);
          setFilesNames(updateArray);
        } else {
          setFilesNames([]);
        }

        if (state.cidScreenShot) {
          setScreenHash(state.cidScreenShot);
        }

        if (state.iconCidDir) {
          setIconHash('');
          const icon = await getFilesFromDirWithContent(ipfs, state.iconCidDir, signal);
          if (icon && icon[0]?.content) {
            const blobIcon = new Blob(icon[0].content);
            const iconUrl = URL.createObjectURL(blobIcon);
            setIconHash(iconUrl);
          }
        }
      })().catch((e) => console.log(e));
    }

    return () => controller.abort();
  }, [step]);

  if (step !== 3) {
    return null;
  }

  return (
    <div className="init-preview">
      <div className="init-preview__gen">
        <div className="init-preview__block">
          <div className="init-preview__block-header">
            <h3 className="init-preview__title">
              {translate.formatMessage({ id: 'wizardForm.step1.generalInformation' })}
            </h3>
            <CustomBtn
              label={translate.formatMessage({ id: 'button-editInfo' })}
              customClass="init-preview__edit-btn"
              handleClick={() => setStep(0)}
              iconClass="icon-pencil-alt"
            />
          </div>
          <div className="init-preview__block-wrapper">
            <div className="init-preview__step1-wrapper">
              <div className="init-preview__wrapper-element">
                <span className="init-preview__label">
                  {translate.formatMessage({ id: 'wizardForm.step1.organizationName' })}
                </span>
                <p className="init-preview__field">
                  {state.developer || ''}
                </p>
              </div>
              <div className="init-preview__wrapper-element">
                <span className="init-preview__label">
                  {translate.formatMessage({ id: 'wizardForm.step1.projectType' })}
                </span>
                <p className="init-preview__field">
                  {getProjectType(state.type, projectTypes(translate)) ? translate.formatMessage({ id: getProjectType(state.type, projectTypes(translate)) }) : ''}
                </p>
              </div>
              <div className="init-preview__wrapper-element">
                <span className="init-preview__label">
                  {translate.formatMessage({ id: 'wizardForm.step1.projectName' })}
                </span>
                <p className="init-preview__field">
                  {state.name || ''}
                </p>
              </div>
            </div>
            <div className="init-preview__step1-wrapper">
              <div className="init-preview__icon-file noscroll">
                <span className="init-preview__label">
                  {translate.formatMessage({ id: 'wizardForm.step1.coverPhoto' })}
                </span>
                {iconHash ? (
                  <div className="init-preview__coverPhoto">
                    <img src={iconHash} alt="img" />
                  </div>
                ) : (
                  <div className="init-preview__coverPhoto project__loading-text">
                    {translate.formatMessage({ id: 'projectInfo.loading' })}
                  </div>
                )}
              </div>
              <div className="init-preview__wrapper-element">
                <span className="init-preview__label">
                  {translate.formatMessage({ id: 'wizardForm.step3.projectDocumentation' })}
                </span>
                <div className="init-preview__files">
                  {filesNames.length > 0 ? (
                    filesNames.map((elem, index) => (
                      <a
                        href={buildGatewayUrl(state.filesCidDir, elem.path)}
                        target="_blank"
                        rel="noreferrer"
                        className="init-preview__filename"
                        key={`span${elem.path}`}
                      >
                        {`${index + 1}. ${elem.path}`}
                      </a>
                    ))
                  ) : (
                    <span className="init-preview__filename-empty">
                      {translate.formatMessage({ id: 'wizardForm.step3.none-warning' })}
                    </span>
                  )}
                </div>
              </div>
              <div className="init-preview__wrapper-element">
                <span className="init-preview__label">
                  {projectDurationType === 'year' ? translate.formatMessage({ id: 'wizardForm.step1.expectedProjectDuration' }) : translate.formatMessage({ id: 'wizardForm.step1.expectedProjectDuration-days' })}
                </span>
                <p className="init-preview__field">
                  {state.projectDuration}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="init-preview__block">
          <div className="init-preview__block-header">
            <h3 className="init-preview__title">
              {translate.formatMessage({ id: 'wizardForm.step2.projectLocation' })}
            </h3>
            <CustomBtn
              label={translate.formatMessage({ id: 'button-editInfo' })}
              customClass="init-preview__edit-btn"
              handleClick={() => setStep(1)}
              iconClass="icon-pencil-alt"
            />
          </div>
          <div className="init-preview__block-wrapper">
            <div className="init-preview__wrapper-element">
              <span className="init-preview__label">
                {translate.formatMessage({ id: 'wizardForm.step2.location' })}
              </span>
              <p className="init-preview__field">
                {state.region || ''}
              </p>
            </div>
            <div className="init-preview__wrapper-element">
              <span className="init-preview__label">
                {translate.formatMessage({ id: 'wizardForm.step2.codePlus' })}
              </span>
              <p className="init-preview__field">
                {state.codePlus || ''}
              </p>
            </div>
            <div className="init-preview__wrapper-element">
              <span className="init-preview__label">
                {translate.formatMessage({ id: 'wizardForm.step3.projectArea' })}
              </span>
              <p className="init-preview__field">
                {state.square || ''}
              </p>
            </div>
            <div className="init-preview__wrapper-element big zone-image">
              <MapMini
                state={state}
              />
            </div>
            <div className="init-preview__wrapper-element project-download">
              <DownloadZone
                customClass=""
                showPosition="bottom"
                fileName={`ofp_${state.name}_nftZone`}
                coordinate={state}
                buttonText={translate.formatMessage({ id: 'sampleData.downloadProjectArea' })}
              />
            </div>
          </div>
        </div>
        <>
          <div className="init-preview__block-header">
            <h3 className="init-preview__title">
              {translate.formatMessage({ id: 'wizardForm.step3.additionalInformation' })}
            </h3>
            <CustomBtn
              label={translate.formatMessage({ id: 'button-editInfo' })}
              customClass="init-preview__edit-btn"
              handleClick={() => setStep(2)}
              iconClass="icon-pencil-alt"
            />
          </div>
          <div className="init-preview__block-wrapper">
            <div className="init-preview__additionalInformation">
              <div className="init-preview__additionalInformation-row">
                <div className="init-preview__additionalInformation-col fullWidth">
                  <span className="init-preview__additionalInformation-label">
                    {translate.formatMessage({ id: 'wizardForm.step3.projectDescription' })}
                  </span>
                  <p className="init-preview__additionalInformation-info maxHeight">
                    {state.aboutProject || ''}
                  </p>
                </div>
              </div>
              <div className="init-preview__additionalInformation-row">
                <div className="init-preview__additionalInformation-col fullWidth">
                  <span className="init-preview__additionalInformation-label">
                    {translate.formatMessage({ id: 'wizardForm.step3.projectGoals' })}
                  </span>
                  <p className="init-preview__additionalInformation-info maxHeight">
                    {state.goals || ''}
                  </p>
                </div>
              </div>
              <div className="init-preview__additionalInformation-row">
                <div className="init-preview__additionalInformation-col  fullWidth">
                  <span className="init-preview__additionalInformation-label">
                    {translate.formatMessage({ id: 'wizardForm.step3.stakeholders' })}
                  </span>
                  <p className="init-preview__additionalInformation-info maxHeight">
                    {state.masters || ''}
                  </p>
                </div>
              </div>
              <div className="init-preview__additionalInformation-row">
                <div className="init-preview__additionalInformation-col fullWidth">
                  <span className="init-preview__additionalInformation-label">
                    {translate.formatMessage({ id: 'wizardForm.step3.coBenefits' })}
                  </span>
                  <p className="init-preview__additionalInformation-info maxHeight">
                    {state.benefits || ''}
                  </p>
                </div>
              </div>
              <div className="init-preview__additionalInformation-row">
                <div className="init-preview__additionalInformation-col">
                  <span className="init-preview__additionalInformation-label">
                    {translate.formatMessage({ id: 'wizardForm.step3.averageTreeDensity' })}
                  </span>
                  <p className="init-preview__additionalInformation-info">
                    <NumberFormat value={state.avgTrees || ''} displayType="text" thousandSeparator />
                  </p>
                </div>
                <div className="init-preview__additionalInformation-col">
                  <span className="init-preview__additionalInformation-label">
                    {translate.formatMessage({ id: 'wizardForm.step3.treeSpecies' })}
                  </span>
                  <p className="init-preview__additionalInformation-info">
                    {state.treeSpecies || ''}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
        <div className="init-preview__btn-wrapper">
          <CustomBtn
            label={translate.formatMessage({ id: 'button-back' })}
            handleClick={() => backTo()}
            type="button"
            customClass="btn__cancel"
          />
          <CustomBtn
            label={translate.formatMessage({ id: 'button-submit' })}
            type="submit"
            handleClick={() => handleMint(state)}
            customClass="btn__next"
          />
        </div>
      </div>
    </div>
  );
};

export default Preview;
